module.exports = __webpack_public_path__ + "static/img/training1.adb3cb89.png";